import React, { useContext, useMemo, useState } from 'react';

import PageLoader from '../components/common/PageLoader';
import StickyPageHeader from '../components/common/StickyPageHeader';
import CarrierOptionsPanel from '../components/panels/CarrierOptionsPanel';
import { AuthContext } from '../contexts/authContext';
import {
  useCarrierOption,
  useSelectedCarrier,
  useUserPermission,
} from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierOptionsPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { carrierId, selectedCarrier } = useSelectedCarrier();
  const { carrierOption, status } = useCarrierOption(carrierId);
  const userHasPermission = useUserPermission();
  const [headerActions, setHeaderActions] = useState(null);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const canView =
    !!selectedCarrier &&
    userHasPermission(selectedCarrier, 'optionPermission');

  const carrierWithOption = useMemo(
    () =>
      selectedCarrier
        ? {
            ...selectedCarrier,
            option: carrierOption ?? selectedCarrier.option,
          }
        : selectedCarrier,
    [selectedCarrier, carrierOption]
  );

  const pageDataLoading = status === 'loading';

  const content =
    canView && (
      <>
        <StickyPageHeader
          actions={headerActions}
          subtitle={selectedCarrier.name}
          title="Options"
        />
        <CarrierOptionsPanel
          carrier={carrierWithOption}
          id="options"
          userRole={authUser?.role}
          onHeaderActions={setHeaderActions}
        />
      </>
    );

  if (disableLayout) {
    return pageDataLoading ? <PageLoader /> : (content || null);
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier || pageDataLoading}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierOptionsPage;
